<template>
  <QualityRawMeasurementTable
    :loading="false"
    :is-detailed="false"
    :measurements="measurements"
  />
</template>

<script>
import { RawMeasurement } from "../../models/Measurement";
import QualityRawMeasurementTable from "../../components/Quality/QualityRawMeasurementTable";
export default {
  name: "MaterialQuality",
  components: { QualityRawMeasurementTable },
  data() {
    return {
      id: this.$route.params.id
    };
  },
  computed: {
    measurements() {
      return RawMeasurement.query()
        .withAllRecursive()
        .whereHas("rawmaterial", query => {
          query.where("material_id", parseInt(this.id));
        })
        .get();
    }
  }
};
</script>
